module.exports = __webpack_public_path__ + "img/cz-partners-investplus.1cabac20.png";